import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_CATEGORY_REFERENCE_DATA = 'GET_CATEGORY_REFERENCE_DATA';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/CategoryManagement/GetCategoryRefrenceData',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CATEGORY_REFERENCE_DATA, service, mock);
